import { IUser } from "../types";

export const emptyUser: IUser = {
  companyCity: "",
  companyState: "",
  entity: "ibioma",
  cpfOrCnpj: "cnpj",
};
